module.exports = __webpack_public_path__ + "img/logo.a31c2ca9.png";